import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=d6e73ca8&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=d6e73ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e73ca8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6e73ca8')) {
      api.createRecord('d6e73ca8', component.options)
    } else {
      api.reload('d6e73ca8', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=d6e73ca8&scoped=true&", function () {
      api.rerender('d6e73ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mIF5o0tAselg/JS/comp/PopupBox.vue"
export default component.exports